
import { getDefaultNamHoc } from "../../../utils/getDefaultValue";
import { IXetTotNghiepActionTypes } from "../../action-types/xet-tot-nghiep/IXetTotNghiepActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IXetTotNghiepReducer } from "../../reducer-model/xet-tot-nghiep/IXetTotNghiepReducer";

const iniState: IXetTotNghiepReducer = {
    status: eReducerStatusBase.is_not_initialization,
    danhSachXetTotNghiepPhamVis: [],

    nam_hoc: getDefaultNamHoc(),
    id_dot_xet: 0,
    id_he: 0,
    id_khoa: 0,
    khoa_hoc: 0,
    id_chuyen_nganh: 0,
    id_lop: 0,
    id_khoi_nganh: 0,
    focusedTab: "dot-xet",
    visibleComboboxDotXetTotNghiep: false,
    isHienThiTheThongKe: true,
    isHienThiBoLocLopXet: false,
}

export const xetTotNghiepReducer = (state: IXetTotNghiepReducer = iniState, action: IXetTotNghiepActionTypes): IXetTotNghiepReducer => {
    switch (action.type) {
        case "XET_TOT_NGHIEP_XET_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
                 isShowProcessing: true,
                 processId: action.payload?.progress_id || undefined,
            };
        case "XET_TOT_NGHIEP_XET_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
            };
        case "XET_TOT_NGHIEP_XET_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "XET_TOT_NGHIEP_LOAD_DANH_SACH_XET_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            };
        case "XET_TOT_NGHIEP_LOAD_DANH_SACH_XET_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                danhSachXetTotNghiepPhamVis: action.payload,        
            };
        case "XET_TOT_NGHIEP_LOAD_DANH_SACH_XET_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "XET_TOT_NGHIEP_CLOSE_PROCESSING_MODAL":
            return {
                ...state,
                isShowProcessing: false,
            };
        case "XET_TOT_NGHIEP_SHOW_THAM_SO_MODAL":
            return {
                ...state,
                isShowThamSoModal: true,
            };
        case "XET_TOT_NGHIEP_CLOSE_THAM_SO_MODAL":
            return {
                ...state,
                isShowThamSoModal: false,
            };
        case "XET_TOT_NGHIEP_SHOW_CAU_HINH_SO_CAO_SO_MODAL":
            return {
                ...state,
                isShowCauHinhSoVaoSoModal: true,
            };
        case "XET_TOT_NGHIEP_CLOSE_CAU_HINH_SO_CAO_SO_MODAL":
            return {
                ...state,
                isShowCauHinhSoVaoSoModal: false,
            };
        case "XET_TOT_NGHIEP_SHOW_CAU_HINH_SO_HIEU_MODAL":
            return {
                ...state,
                isShowCauHinhSoHieuModal: true,
            };
        case "XET_TOT_NGHIEP_CLOSE_CAU_HINH_SO_HIEU_MODAL":
            return {
                ...state,
                isShowCauHinhSoHieuModal: false,
            };
        case "XET_TOT_NGHIEP_SHOW_CAU_HINH_SO_QUYET_DINH_MODAL":
            return {
                ...state,
                isShowCauHinhSoQuyetDinhModal: true,
            };
        case "XET_TOT_NGHIEP_CLOSE_CAU_HINH_SO_QUYET_DINH_MODAL":
            return {
                ...state,
                isShowCauHinhSoQuyetDinhModal: false,
            };
        case "XET_TOT_NGHIEP_SHOW_CAU_HINH_SO_IN_QUYET_DINH_MODAL":
            return {
                ...state,
                isShowCauHinhSoInQuyetDinhModal: true,
            };
        case "XET_TOT_NGHIEP_CLOSE_CAU_HINH_SO_IN_QUYET_DINH_MODAL":
            return {
                ...state,
                isShowCauHinhSoInQuyetDinhModal: false,
            };
        case "XET_TOT_NGHIEP_SINH_VIEN_DU_DIEU_KIEN_CHANGE_SELECTED_IDS":
            return {
                ...state,
                sinhVienDuDieuKienSelectedIds: action.payload
            };
        case "XET_TOT_NGHIEP_SINH_VIEN_KHONG_DU_DIEU_KIEN_CHANGE_SELECTED_IDS":
            return {
                ...state,
                sinhVienKhongDuDieuKienSelectedIds: action.payload
            };
        case "XET_TOT_NGHIEP_CHANGE_NAM_HOC":
            return {
                ...state,
                nam_hoc: action.payload
            };
        case "XET_TOT_NGHIEP_CHANGE_ID_DOT_XET":
            return {
                ...state,
                id_dot_xet: action.payload,
                id_he: 0,
                id_khoa: 0,
                khoa_hoc: 0,
                id_chuyen_nganh: 0,
                id_lop: 0,
                id_khoi_nganh: 0,
                sinhVienDuDieuKienSelectedIds: [],
                sinhVienKhongDuDieuKienSelectedIds: [],
            };
        case "XET_TOT_NGHIEP_CHANGE_ID_HE":
            return {
                ...state,
                id_he: action.payload
            };
        case "XET_TOT_NGHIEP_CHANGE_ID_KHOA":
            return {
                ...state,
                id_khoa: action.payload
            };
        case "XET_TOT_NGHIEP_CHANGE_KHOA_HOC":
            return {
                ...state,
                khoa_hoc: action.payload
            };
        case "XET_TOT_NGHIEP_CHANGE_ID_CHUYEN_NGANH":
            return {
                ...state,
                id_chuyen_nganh: action.payload
            };
        case "XET_TOT_NGHIEP_CHANGE_ID_LOP":
            return {
                ...state,
                id_lop: action.payload
            };
        case "XET_TOT_NGHIEP_CHANGE_ID_KHOI_NGANH":
            return {
                ...state,
                id_khoi_nganh: action.payload
            };
        case "XET_TOT_NGHIEP_CHANGE_FOCUSED_TAB":
            return {
                ...state,
                focusedTab: action.payload
            };
        case "XET_TOT_NGHIEP_CHANGE_VISIBLE_COMBBOX_DOT_XET_TOT_NGHIEP":
            return {
                ...state,
                visibleComboboxDotXetTotNghiep: action.payload
            };
        case "XET_TOT_NGHIEP_CHANGE_IS_HIEN_THI_THE_THONG_KE":
            return {
                ...state,
                isHienThiTheThongKe: action.payload
            };
        case "XET_TOT_NGHIEP_CHANGE_IS_HIEN_THI_BO_LOC_LOP_XET":
            return {
                ...state,
                isHienThiBoLocLopXet: action.payload
            };
        case "XET_TOT_NGHIEP_XET_KET_QUA_HOC_TAP_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            };
        case "XET_TOT_NGHIEP_XET_KET_QUA_HOC_TAP_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
            };
        case "XET_TOT_NGHIEP_XET_KET_QUA_HOC_TAP_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "XET_TOT_NGHIEP_XET_CHUNG_CHI_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            };
        case "XET_TOT_NGHIEP_XET_CHUNG_CHI_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
            };
        case "XET_TOT_NGHIEP_XET_CHUNG_CHI_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        default:
            return state;
    }
}